import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PropsWithClassName } from "~/utils/types";

const SpinnerIcon = ({ className }: PropsWithClassName) => {
  return <FontAwesomeIcon icon={faSpinner} spin className={className} />;
};

export default SpinnerIcon;
